import React, { Component } from "react";

import { Access, PermissionsEnum } from "common";
import { Breadcrumbs, Navigation, Page } from "components";

class Dashboard extends Component {
  state = {
    breadcrumbs: [{ name: "Home", to: "" }],
    navigation: [
      {
        name: "Relatórios",
        to: "/reports",
        hidden: !Access.hasPermissions([
          "manage-report-ranking-points",
          "manage-report-ranking-registers",
          "manage-report-provisioned-vouchers",
          "manage-events-attendance",
          "manage-report-provisioned-points",
          "manage-report-average-tickets",
          "manage-report-points",
          "manage-report-benefits",
        ]),
      },
      {
        name: "Pontos",
        to: "/points",
        hidden: !Access.hasPermissions([
          "manage-vouchers",
          "manage-channels",
          "manage-places",
          "manage-payment-methods",
          "manage-product-types",
        ]),
      },
      {
        name: "Profissionais EAD",
        to: "/professionals",
        hidden: !Access.hasPermissions([
          "view-customer-presential",
          "manage-customer-presential",
          "manage-presencial-docs",
        ]),
      },
      {
        name: "Benefícios",
        to: "/benefits",
        hidden: !Access.hasPermissions("manage-benefits"),
      },
      {
        name: "Eventos",
        to: "/events",
        hidden: !Access.hasPermissions("manage-events"),
      },
      {
        name: "Regiões",
        to: "/regions",
        hidden: !Access.hasPermissions("manage-regions"),
      },
      {
        name: "Extração",
        to: "/extraction",
        hidden: !Access.hasPermissions("manage-extraction"),
      },
      {
        name: "Configurações",
        to: "/configs",
        hidden: !Access.hasPermissions([
          "edit-messages",
          "edit-users",
          "edit-access-groups",
          "edit-permissions",
          "edit-variables",
          "edit-log",
          "edit-incidents",
        ]),
      },
      {
        name: "Documentos",
        to: "/documents",
        hidden: !Access.hasPermissions("manage-documents"),
      },
      {
        name: "PRO",
        to: "/pro",
        hidden: !Access.hasPermissions([
          "manage-inhabitant-segments",
          "view-inhabitant-segments",
          "view-cashback-imports",
          "manage-cashback-imports",
        ]),
      },
      {
        name: "Campanhas de Cashback Externo",
        to: "/external-cashback-campaigns/list",
        hidden: !Access.hasPermissions([
          PermissionsEnum.VIEW_EXTERNAL_CASHBACK_CAMPAIGN,
          PermissionsEnum.EDIT_EXTERNAL_CASHBACK_CAMPAIGN,
        ]),
      },
      {
        name: "Processamentos",
        to: "/processes/list",
        hidden: false,
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Dashboard;
